import { Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';
import { Button, LgSpace, MdSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { componentsPropsValues, localizedTextsMap, rowsPerPageOptionsValues } from 'utils/dataGrid/dataGridUtils';
import { RootState } from 'store';
import { ParametrizacoesResponse } from 'store/modules/parametrizacoes/parametrizacoesResponse';
import { AtivarDesativarParametrizacoesRequest } from 'common/genericTypes';
import { addAlert } from 'store/modules/snackBar';
import CustomToolBarUtils from 'utils/dataGrid/customToolBar';
import {
  DataGridPro,
  GridCellParams,
  GridValueGetterParams,
} from '@mui/x-data-grid-pro';

export const Parametrizacoes: React.FC = (props) => {
  const getParametrizacaoList = useSelector((state: RootState) => state.parametrizacaoApi.getParametrizacoes);
  const putParametrizacoes = useSelector(
    (state: RootState) => state.parametrizacaoApi.putAtivarDesativarParametrizacoes
  );
  const [parametrizacoesList, setParametrizacoes] = useState<Array<ParametrizacoesResponse>>([]);
  const [pageSize, setPageSize] = React.useState(5);
  const [botaoDesativar, setBotaoDesativar] = useState<boolean>(false);
  const [botaoAtivar, setBotaoAtivar] = useState<boolean>(false);
  const [listSelected, setListSelected] = useState<Array<any>>([]);
  const dispatch = useDispatch();

  const getParametrizacoes = useCallback(async () => {
    try {
      const result = await getParametrizacaoList(dispatch, true);
      setParametrizacoes(result.data);
    } catch (error) { }
  }, [dispatch, getParametrizacaoList]);

  useEffect(() => {
    getParametrizacoes();
  }, [getParametrizacoes]);

  const getGridColumns = useCallback(
    () => [
      {
        field: 'id',
        headerName: 'Id',
        valueGetter: (params: GridValueGetterParams) => (params.row as ParametrizacoesResponse).id,
        width: 50,
        minWidth: 50,
        maxWidth: 300,
        resizable: true,
      },
      {
        field: 'nomeFuncionalidade',
        headerName: 'Funcionalidade',
        valueGetter: (params: GridValueGetterParams) => (params.row as ParametrizacoesResponse).nomeFuncionalidade,
        width: 320,
        minWidth: 320,
        maxWidth: 500,
        resizable: true,
      },
      {
        field: 'descricao',
        headerName: 'Descrição',
        valueGetter: (params: GridValueGetterParams) => (params.row as ParametrizacoesResponse).descricao,
        width: 280,
        minWidth: 280,
        maxWidth: 500,
        resizable: true,
      },
      {
        field: 'atualizadoEm',
        headerName: 'Atualizado Em',
        valueGetter: (params: GridValueGetterParams) => (params.row as ParametrizacoesResponse).alteradoEm,
        width: 220,
        minWidth: 150,
        maxWidth: 300,
        resizable: true,
      },
      {
        field: 'ativo',
        headerName: 'Ativo',
        renderCell: (params: GridCellParams) => {
          return <FormControlLabel control={<Checkbox color={'primary'} checked={params.row.ativo} />} label="Ativo" />;
        },
        resizable: true,
      },
    ],
    []
  );

  function onSelected(selected: any) {
    setListSelected(selected);
    if (selected.length === 0) {
      setBotaoAtivar(false);
      setBotaoDesativar(false);
      return;
    }
    setBotaoAtivar(true);
    setBotaoDesativar(true);
  }

  const onAtivarDesativarClick = async (ativar: boolean) => {
    try {
      const toSendList = [] as Array<AtivarDesativarParametrizacoesRequest>;
      listSelected.map((id) => {
        toSendList.push({ ativo: ativar, funcionalidadeId: id });
      });
      await putParametrizacoes(dispatch, toSendList);
      dispatch(
        addAlert({
          message: ativar ? 'Parametros ativados com sucesso!' : 'Parametros desativados com sucesso!',
          severity: 'success',
        })
      );
      await getParametrizacoes();
    } catch {
      dispatch(
        addAlert({
          message: ativar ? 'Ocorreu um erro ao Ativar os parâmetros!' : 'Ocorreu um erro ao Desativar os parâmetros!',
          severity: 'error',
        })
      );
    }
  };

  return (
    <div style={{ marginRight: 50 }}>
      <Grid container justify={'space-between'} direction={'row'} alignItems={'center'}>
        <Typography variant="h1">{'Parametrizações'}</Typography>
      </Grid>
      <LgSpace />
      <>
        <Grid container justify="center">
          <Grid item>
            <Button
              disabled={!botaoAtivar}
              onClick={() => onAtivarDesativarClick(true)}
              variant="contained"
              color="primary"
            >
              {'ATIVAR'}
            </Button>
            <MdSpace />
          </Grid>
          <Grid item style={{ marginLeft: 50 }}>
            <Button
              disabled={!botaoDesativar}
              onClick={() => onAtivarDesativarClick(false)}
              variant="contained"
              color="error"
            >
              {'DESATIVAR'}
            </Button>
            <MdSpace />
          </Grid>
        </Grid>

        <div style={{ height: 400 }}>
          <DataGridPro
            checkboxSelection
            onSelectionModelChange={(newSelectionModel) => {
              onSelected(newSelectionModel);
            }}
            localeText={localizedTextsMap}
            componentsProps={componentsPropsValues}
            rows={parametrizacoesList}
            columns={getGridColumns()}
            components={{
              Toolbar: CustomToolBarUtils,
            }}
            disableSelectionOnClick
            rowsPerPageOptions={rowsPerPageOptionsValues}
            pagination
            onPageSizeChange={(newPage) => setPageSize(newPage)}
            pageSize={pageSize}
            loading={parametrizacoesList.length === 0}
          />
        </div>
      </>
    </div>
  );
};

export default Parametrizacoes;
